import * as Sentry from '@sentry/react';

class SentryService {
  private static readonly DEFAULT_FLUSH_TIMEOUT_MS = 2000;

  init(dsnKey: string) {
    if (process.env.NODE_ENV !== 'production') {
      return;
    }

    Sentry.init({
      dsn: dsnKey,
      environment: process.env.NODE_ENV,
    });
  }

  captureException(error: unknown, context?: Record<string, unknown>) {
    if (error instanceof Error) {
      Sentry.captureException(error, {
        extra: context,
      });
    } else {
      let errorMessage: string;

      try {
        errorMessage = JSON.stringify(error, null, 2);
      } catch {
        errorMessage = String(error);
      }

      Sentry.captureException(new Error(errorMessage), {
        extra: context,
      });
    }
  }

  captureMessage(message: string, level: Sentry.SeverityLevel = 'info') {
    Sentry.captureMessage(message, level);
  }

  setUser(user: { id?: string; email?: string; username?: string }) {
    Sentry.setUser(user);
  }

  setTag(key: string, value: string) {
    Sentry.setTag(key, value);
  }

  setContext(name: string, context: Record<string, unknown>) {
    Sentry.setContext(name, context);
  }

  async flush(timeout = SentryService.DEFAULT_FLUSH_TIMEOUT_MS) {
    return await Sentry.flush(timeout);
  }
}

const sentry = new SentryService();

export { sentry };
